// extracted by mini-css-extract-plugin
export var grayCircle = "_do-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_do-1";
export var selectedCircle = "_do-2";
export var shippingOptionImage = "_do-3";
export var shippingOptionWidgetPreview = "_do-4";